/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EvmContractSourceCodeEntity } from './EvmContractSourceCodeEntity';
import type { EvmProxyContractInfo } from './EvmProxyContractInfo';

export type ZerogContractCodeInfo = {
    CNM: string;
    CV: string;
    EV: string;
    OPT: ZerogContractCodeInfo.OPT;
    VD: number;
    PRXINFO: EvmProxyContractInfo;
    SCLIST: Array<EvmContractSourceCodeEntity>;
    ABI: string;
    DBC: string;
    RUN: string;
};

export namespace ZerogContractCodeInfo {

    export enum OPT {
        Y = 'Y',
        N = 'N',
    }


}

